export default {
  OUT_OF_STOCK_ONLINE: 101,
  PARTIAL_OUT_OF_STOCK_ONLINE: 102,
  SIF_RESTRICTION: 104,
  SHIP_METHOD_RESTRICTION: 106,
  OUT_OF_STOCK_STERLING: 107,
  PARTIAL_OUT_OF_STOCK_STERLING: 108,
  NO_ELIGIBLE_LOCATIONS_BY_SRP: 110,
}
